export const supportsCssFlip =
  typeof CSS !== 'undefined' &&
  CSS.supports('animation-timeline: scroll()') &&
  CSS.supports('animation-range: 0% 100%');
